/**
 * CMSPreferenceDirective class handles the compilation and rendering of CMS preference directives.
 * It uses AngularJS services to fetch task information and compile HTML content based on preference data.
 */
export class CMSPreferenceDirective {
    /**
     * Constructs a new instance of CMSPreferenceDirective.
     * @param {Object} $compile - AngularJS $compile service.
     * @param {Object} $bridges - Custom service for bridge operations.
     * @param {Object} TaskDataService - Service to fetch task data.
     * @param {Object} TaskInfoService - Service to fetch task information.
     */
    constructor($compile, $bridges, TaskDataService, TaskInfoService) {
        this.$compile = $compile;
        this.$bridges = $bridges;
        this.TaskDataService = TaskDataService;
        this.TaskInfoService = TaskInfoService;
        this._logIdentifier = 'CMSPreferenceDirective';
    }

    /**
     * Link function to process the directive's scope, element, and attributes.
     * @param {Object} scope - AngularJS scope object.
     * @param {Object} element - jQuery-like element object.
     * @param {Object} iAttrs - Attributes of the directive.
     */
    link(scope, element, iAttrs) {
        const taskInfo = this.TaskInfoService.getTaskInfo();
        scope.parentScope.writingDirection = taskInfo.getInputLanguage().writingDirection.toUpperCase();

        let htmlContent = '';
        const data = scope.prefData,
              cmsTypes = ['checkbox', 'select', 'input', 'jtextarea', 'colorpicker', 'multiselect', 'multiselect-small','select-other-content-object', 'textarea', 'spacer'];

        angular.forEach(data, (value, key) => {
            // SMELL: Using console.info for logging might not be ideal for production environments.
            // console.info('[' + this._logIdentifier + '] got type: ' + value.type);
            if (cmsTypes.indexOf(value.type) !== -1) {
                if (value.type.toLowerCase() === 'spacer') {
                    htmlContent += '<span>&nbsp;</span>';
                } else {
                    htmlContent += angular.element('<cms-preference-{type} scope="parentScope" key="{key}" data="prefData" class="cms-{type} {extraCssClass}"></cms-preference-{type}>',
                        { type: value.type, key: key }
                    ).html();
                }
            }
        });

        element.html(htmlContent);
        // Compile the element's contents with the current scope
        this.$compile(element.contents())(scope);
    }
}

/**
 * Registers the CMSPreferenceDirective as an AngularJS directive.
 * @param {Object} module - AngularJS module to which the directive will be registered.
 */
export default function registerCMSPreferenceDirective(module) {
    module.directive('cmsPreference', ['$compile', '$bridges', 'TaskDataService', 'TaskInfoService', function($compile, $bridges, TaskDataService, TaskInfoService) {
        return {
            restrict: 'EA',
            replace: true,
            scope: {
                parentScope: '=scope',
                prefData: '=data'
            },
            link: (scope, element, iAttrs) => {
                const directive = new CMSPreferenceDirective($compile, $bridges, TaskDataService, TaskInfoService);
                directive.link(scope, element, iAttrs);
            }
        };
    }]);
}